const TOKEN_STORAGE_KEY = "coloca_auth_token";
const REFRESH_TOKEN_STORAGE_KEY = "coloca_refresh_token";

export class TokenStorageService {
  private static isLocalhost(): boolean {
    const hostname = window.location.hostname;
    return hostname === "localhost" || hostname === "127.0.0.1";
  }

  static getToken(): string | null {
    if (!this.isLocalhost()) return null;
    return localStorage.getItem(TOKEN_STORAGE_KEY);
  }

  static setToken(token: string): void {
    if (!this.isLocalhost()) return;
    localStorage.setItem(TOKEN_STORAGE_KEY, token);
  }

  static clearToken(): void {
    if (!this.isLocalhost()) return;
    localStorage.removeItem(TOKEN_STORAGE_KEY);
  }

  static hasToken(): boolean {
    return !!this.getToken();
  }

  static getRefreshToken(): string | null {
    if (!this.isLocalhost()) return null;
    return localStorage.getItem(REFRESH_TOKEN_STORAGE_KEY);
  }

  static setRefreshToken(token: string): void {
    if (!this.isLocalhost()) return;
    localStorage.setItem(REFRESH_TOKEN_STORAGE_KEY, token);
  }

  static clearRefreshToken(): void {
    if (!this.isLocalhost()) return;
    localStorage.removeItem(REFRESH_TOKEN_STORAGE_KEY);
  }
}
